import React from "react";
import ContentLoader from "react-content-loader";

export const ImageLoader = ({height}) => (
    <ContentLoader width="100%"height={height ?? "100%"} backgroundColor="#f6f7f6" foregroundColor="#eee">
        <rect x="0" y="0" rx="4" ry="4" width="100%" height={height ?? "100%"} />
    </ContentLoader>
);
export const TitleLoader = () => (
    <ContentLoader viewBox="0 0 250 20" height={20} width={250}>
        <rect x="0" y="0" rx="4" ry="4" width="100%" height="20" />
    </ContentLoader>
);
export const DescriptionLoader = () => (
    <ContentLoader  height={50}>
        <rect x="0" y="0" rx="4" ry="4" width="100%" height="50" />
    </ContentLoader>
);

export const DeveloperLoader = () => (
    <ContentLoader viewBox="0 0 176 20" height={20} width={176}>
        <rect x="0" y="0" rx="4" ry="4" width="60%" height="20" />
    </ContentLoader>
);
export const PropertyLoader = () => (
    <ContentLoader viewBox="0 0 60 30" height={30} width={60}>
        <rect x="0" y="0" rx="4" ry="6" width="100%" height="30" />
    </ContentLoader>
);

export const LocationLoader = () => (
    <ContentLoader viewBox="0 0 200 10" height={10} width={200}>
        <rect x="0" y="0" rx="4" ry="4" width="80%" height="10" />
    </ContentLoader>
);

export const PriceLoader = () => (
    <ContentLoader viewBox="0 0 150 20" height={20} width={150}>
        <rect x="0" y="0" rx="4" ry="4" width="50%" height="20" />
    </ContentLoader>
);

export const CompletionLoader = () => (
    <ContentLoader viewBox="0 0 75 30" height={30} width={75}>
        <rect x="0" y="0" rx="4" ry="4" width="80%" height="15" />
        <rect x="0" y="20" rx="4" ry="4" width="60%" height="10" />
    </ContentLoader>
);
